<template>
  <div>
    <div class="filter-container">
      <div class="filter-group">
        <div id="date-filter" v-if="statusFilter === 'Fechado'">
          <label for="" >De</label>
          <input type="date" class="form-control custom-width" :disabled="statusFilter !== 'Fechado'" v-model="filters.startDate">
          <label for="" >Até</label>
          <input type="date" class="form-control custom-width" :disabled="statusFilter !== 'Fechado'" v-model="filters.endDate">
          <button type="button" id="search-button" class="btn mb-0 filter-buttons" :disabled="statusFilter !== 'Fechado'" @click="getRequests()">
            <i class="fa fa-search" aria-hidden="true"></i>   Buscar
          </button>
          <button type="button" id="reset-button" class="btn mb-0 filter-buttons" @click="resetFilters()">
            <i class="fa fa-times" aria-hidden="true"></i>   Limpar
          </button>
        </div>
        <div class="search-container">
          <input 
            type="text" 
            class="form-control custom-width" 
            placeholder="Pesquisar..." 
            v-model="searchTerm"
            style="width: 100%;"
          >
        </div>
      </div>
      <div class="filter-group">
        <div class="header-filter">
          <label for="header-filter">Canal</label>
          <select v-model="channelFilter" class="form-control custom-width">
            <option value="*" selected>Todos</option>
            <option v-for="channel in channelsList" :key="channel">{{ channel }}</option>
          </select>
        </div>
        <div class="header-filter">
          <label for="header-filter">Motivo de acionamento</label>
          <select v-model="reasonFilter" class="form-control custom-width">
            <option value="*" selected>Todos</option>
            <option v-for="reason in reasonsList" :key="reason">{{ reason }}</option>
          </select>
        </div>
        <div class="header-filter">
          <label for="header-filter">Área</label>
          <select v-model="sectorFilter" class="form-control custom-width">
            <option value="*" selected>Todos</option>
            <option value="">Não atribuído</option>
            <option>N1 - Atendimento a Clientes</option>
            <option>N2 - Suporte e Gestão de Serviços</option>
            <option>N2 - Gestão de Cofre Inteligente</option>
          </select>
        </div>
        <div class="header-filter">
          <label for="header-filter">Status</label>
          <select v-model="statusFilter" class="form-control custom-width">
            <option value="*">Todos</option>
            <option value="ativo" selected>Aberto e em andamento</option>
            <option>Aberto</option>
            <option>Em andamento</option>
            <option>Fechado</option>
          </select>
        </div>
        <div class="header-filter">
          <label for="header-filter">Desvio de procedimento</label>
          <select v-model="deviationFilter" class="form-control custom-width">
            <option value="*" selected>Todos</option>
            <option value="sim">Sim</option>
            <option value="nao">Não</option>
          </select>
        </div>
      </div>
    </div>

    <hr>
    <b-button variant="success" style="margin-right: -4px;" @click="generateExcel">EXCEL <b-icon icon="file-earmark-excel" aria-hidden="true"></b-icon></b-button>
    <br>

    <b-row class="justify-content-between" style="overflow-x: auto">
      <b-col md="12">
        <b-table
            striped
            hover
            bordered
            sort-icon-left
            show-empty
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :items="filteredItems"
            :fields="fields"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
            :current-page="currentPage"
            :per-page="perPage"
            thead-class="font-weight-bold"
            :sort-compare="sortDate"
            table-class="table-sm small"
        >

          <template #empty="">
              <h6 style="text-align: center">Nenhum resultado encontrado.</h6>
          </template>

          <!-- Formatar campo status -->
          <template #cell(status)="data">
            {{ data.item.status }}
          </template>

          <template #cell(type)="data">
            {{ parseType(data.item.type) }}
          </template>

          <!-- Formatar campo data -->
          <template #cell(phone)="data">
            {{ formTelefone(data.item.phone) }}
          </template>

          <!-- Formatar campo telefone -->
          <template #cell(created_at)="data">
            {{ moment(data.item.created_at).format('DD/MM/YYYY \à\\s HH:mm') }}
          </template>

          <template #cell(updated_at)="data">
            {{ moment(data.item.updated_at).format('DD/MM/YYYY \à\\s HH:mm') }}
          </template>

          <template #cell(sector)="data">
            {{ data.item.sector || 'Não atribuído' }}
          </template>

          <template #cell(sla)="data">
            <span v-html="handleSolicitationSLA(data.item)"></span>
          </template>

          <template #cell(sla_att)="data">
            <span v-html="handleSolicitationSLA(data.item, true)"></span>
          </template>

          <template v-slot:cell(view-button)="{ item }">
            <span>
              <b-btn style="background-color: #1c869a" id="view-button" @click.prevent="getDetails({item, reloadDetails: true})">
                   <i class="fas fa-eye fa-fw"></i>
              </b-btn>
            </span>
          </template>

          <template #cell(created_by)="data">
            {{ parseCreator(data.item) }}
          </template>

          <template #cell(requestType)="data">
            {{ parseReason(data.item.requestType) }}
          </template>

        </b-table>

      </b-col>
    </b-row>

    <b-row class="justify-content-between">
      <b-col md="4">
        <b-form-group
            label="Registros por página"
            label-for="per-page-select"
            label-cols-md="6"
            label-align-sm="right"
            label-size="sm"
            class="mb-0 align-self-center"
        >
          <b-form-select
              id="per-page-select"
              v-model="perPage"
              :options="pageOptions"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col sm="7" md="6" class="my-1">
        <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="right"
            size="md"
            class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>

    <details-modal v-if="getlogchat && Object.keys(getlogchat).length" ref="detailsModal" v-on:reload="getRequests(), getDetails($event)"/>

  </div>

</template>

<script>
import {mapMutations, mapGetters} from 'vuex'
import moment from 'moment';
import * as XLSX from 'xlsx';
import { handleSolicitationSLA } from "../../helpers/utils"

export default {
  props: {
    emailGroups: {
      type: Array,
      default: () => []
    },
    wppGroups: {
      type: Array,
      default: () => []
    },
    autoOpenProtocol: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      moment: moment,
      fields: [
        { key: 'created_at', label: 'Data de Criação', class: 'text-center', thStyle: {backgroundColor: '#1c869a', color: '#ffffff'}, sortable: true },
        { key: 'created_by', label: 'Criado por', class: 'text-center', thStyle: {backgroundColor: '#1c869a', color: '#ffffff'}, sortable: true },
        { key: 'updated_at', label: 'Data de Alteração', class: 'text-center', thStyle: {backgroundColor: '#1c869a', color: '#ffffff'}, sortable: true },
        { key: 'updated_by', label: 'Alterado por', class: 'text-center', thStyle: {backgroundColor: '#1c869a', color: '#ffffff'}, sortable: true },
        { key: 'protocol', label: 'Chamado', class: 'text-center', thStyle: {backgroundColor: '#1c869a', color: '#ffffff'}, sortable: true },
        { key: 'attProtocol', label: 'Protocolo', class: 'text-center', thStyle: {backgroundColor: '#1c869a', color: '#ffffff'}, sortable: true },
        { key: 'name',  label: 'Solicitante', class: 'text-center', thStyle: {backgroundColor: '#1c869a', color: '#ffffff'}, sortable: true },
        { key: 'phone', label: 'Telefone', class: 'text-center', thStyle: {backgroundColor: '#1c869a', color: '#ffffff'}, sortable: true },
        { key: 'cnpj', label: 'CNPJ', class: 'text-center', thStyle: {backgroundColor: '#1c869a', color: '#ffffff'}, sortable: true },
        { key: 'client_name', label: 'Cliente', class: 'text-center', thStyle: {backgroundColor: '#1c869a', color: '#ffffff'}, sortable: true },
        { key: 'ponto_name', label: 'Ponto', class: 'text-center', thStyle: {backgroundColor: '#1c869a', color: '#ffffff'}, sortable: true },
        { key: 'channel', label: 'Canal', class: 'text-center', thStyle: {backgroundColor: '#1c869a', color: '#ffffff'}, sortable: true },
        { key: 'requestType', label: 'Motivo de Acionamento', class: 'text-center', thStyle: {backgroundColor: '#1c869a', color: '#ffffff'}, sortable: true },
        { key: 'sla', label: 'SLA', class: 'text-center', thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }, sortable: true },
        { key: 'sla_att', label: 'Primeiro Atendimento', class: 'text-center', thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }, sortable: true },
        { key: 'sector', label: 'Área Responsável', class: 'text-center', thStyle: {backgroundColor: '#1c869a', color: '#ffffff'}, sortable: true },
        { key: 'status', label: 'Status', class: 'text-center', thStyle: {backgroundColor: '#1c869a', color: '#ffffff'}, sortable: true },
        {
          key: 'view-button',
          label: 'Visualizar',
          sortable: true,
          class: 'text-center',
          thStyle: {backgroundColor: '#1c869a', color: '#ffffff', width: '100px'}
        }
      ],
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15, { value: 100, text: "Ver mais" }],
      sortBy: 'created_at',
      sortDesc: false,
      filter: null,
      filterOn: [],
      filters: {
        startDate: '',
        endDate: '',
      },
      searchTerm: '',
      items: [],
      infoModal: {},
      statusFilter: 'ativo',
      sectorFilter: '*',
      reasonFilter: '*',
      channelFilter: '*',
      typeFilter: '*',
      deviationFilter: '*',
      autoOpenTriggered: false
    }
  },
  computed:{
    ...mapGetters(['getlogchat']),
    reasonsList(){
      const reasonsArray = []
      this.items.map(el => {
        const reason = this.parseReason(el.requestType)
        if(!reasonsArray.includes(reason)) reasonsArray.push(reason)
      })
      return reasonsArray.sort()
    },
    channelsList(){
      const channelsArray = []
      this.items.map(el => {
        if(!channelsArray.includes(el.channel)) channelsArray.push(el.channel)
      })
      return channelsArray.sort()
    },
    totalRows(){
      return this.filteredItems.length;
    },
    filteredItems(){
      let tempArray = this.items;

      if(this.statusFilter !== '*'){
        if(this.statusFilter === 'ativo'){
          tempArray = tempArray.filter(el => el.status === 'Em andamento' || el.status === 'Aberto')
        } else {
          tempArray = tempArray.filter(el => el.status === this.statusFilter)
        }
      } 
      if(this.sectorFilter !== '*') tempArray = tempArray.filter(el => el.sector === this.sectorFilter)
      if(this.reasonFilter !== '*') tempArray = tempArray.filter(el => this.parseReason(el.requestType) === this.reasonFilter)
      if(this.channelFilter !== '*') tempArray = tempArray.filter(el => el.channel === this.channelFilter)
      if(this.deviationFilter !== '*') tempArray = tempArray.filter(el => !!el.procedure_deviation?.has_deviation === (this.deviationFilter === 'sim'))
      if(this.typeFilter !== '*'){
        tempArray = tempArray.filter(el => {
          const typeFilterArray = this.typeFilter.split('|')
          const type = typeFilterArray[0]
          const subject = typeFilterArray[1]

          if((el.type === type && el.subject === subject) || (el.type === 'outros' && type === 'outros')) return el
        })
      }
      if(this.searchTerm !== '') tempArray = tempArray.filter(el => {
        const keyword = this.searchTerm.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^\w\s]/g, '');
        return [
          el.protocol,
          el.attProtocol,
          el.name,
          el.phone,
          el.cnpj,
          el.name,
          el.client_name,
          el.address,
          el.ponto_name,
          el.created_by,
          el.updated_by,
          el.sector,
          el.reason,
          el.subject,
          el.type
        ].some(
          field => field && field.toString()
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[^\w\s]/g, '')
          .includes(keyword)
        );
      })

      return tempArray;
    }
  },
  methods : {
    handleSolicitationSLA,
    ...mapMutations(['setLogChat']),
    sortDate(a, b, key) {
      if (key !== 'created_at' && key !== 'updated_at') {
        return null;
      }
      let aDate = moment(a[key], 'YYYY-MM-DD HH:mm:ss')
      let bDate = moment(b[key], 'YYYY-MM-DD HH:mm:ss')
      if (aDate.isValid && bDate.isValid) {
        if (aDate < bDate) {
          return -1
        }
        else if (aDate > bDate) {
          return 1
        }
        else {
          return 0
        }
      }
      return null
    },

    ...mapMutations(['setLogChat']),

    sortDate(a, b, key) {
      if (key !== 'created_at' && key !== 'updated_at') {
        return null;
      }
      let aDate = moment(a[key], 'YYYY-MM-DD HH:mm:ss')
      let bDate = moment(b[key], 'YYYY-MM-DD HH:mm:ss')
      if (aDate.isValid && bDate.isValid) {
        if (aDate < bDate) {
          return -1
        }
        else if (aDate > bDate) {
          return 1
        }
        else {
          return 0
        }
      }
      return null
    },

    onFiltered(filteredItems) {
      this.currentPage = 1
    },
    async getDetails(data){
      if(!data.reloadDetails) return
      const item = data.item
      const survey = await axios.get(`/solicitacoes/getSatisfactionDetails/${item.protocolo}`).then(({data}) => {
        if(data){
          return data
        }
        return {}
      })
      const requestData = await axios.get('/solicitacoes/getRequestById', {params: {id: item._id}}).then(({data}) => {
        if(data){
          return data
        }
        return null
      })

      if(requestData){
        let emailData = null;
        if(requestData.attProtocol){
          emailData = await axios.get('/solicitacoes/getEmailsByProtocol', {params: {protocol: requestData.attProtocol}}).then(({data}) => { return data || null })
        }
        const phone = requestData.client_id.substring(0, requestData.client_id.indexOf('@'))
        const infoModal = {
          channel: this.parseChannel(requestData),
          id: requestData.client_id || requestData.id,
          _id: requestData._id,
          nome: (requestData.relato.nome || requestData.name) || 'Não identificado',
          texto: requestData.relato.descricao || requestData.relato.texto || requestData.relato.solicitacaoTexto,
          contato: this.formTelefone(phone),
          cnpj: requestData.cnpj,
          chamado: requestData.protocol,
          protocolo: requestData.attProtocol,
          motivo: this.parseReason(requestData.relato, 'details'),
          cidade: requestData.relato.cidade,
          local: requestData.relato.local,
          placa: requestData.relato.veiculo?.placa || null,
          prefixo: requestData.relato.veiculo?.prefixo || null,
          sufixo: requestData.relato.veiculo?.sufixo || null,
          nomeBase: requestData.relato.veiculo?.nomeBase,
          siglaBase: requestData.relato.veiculo?.siglaBase,
          placaSolicitante: requestData.relato.placaSolicitante,
          solicitacaoData: requestData.relato.data || requestData.relato.solicitacaoreclamacaoData,
          solicitacaoHora: requestData.relato.hora || requestData.relato.solicitacaoHora,
          matricula: requestData.matricula,
          status: requestData.relato.status,
          NomeCliente: requestData.clientInfo?.NomeCliente,
          endereco: requestData.clientInfo?.EnderecoPonto,
          cep: requestData.clientInfo?.CEPCliente,
          nomePonto: requestData.clientInfo?.NomePonto,
          codigoPonto: requestData.clientInfo?.CodigoPonto,
          Base: requestData.clientInfo?.Base,
          created_at: moment(requestData.created_at).format('DD/MM/YYYY \à\\s HH:mm'),
          updated_at: moment(requestData.updated_at).format('DD/MM/YYYY \à\\s HH:mm'),
          updated_by: requestData.updated_by,
          created_by: this.parseCreator(requestData),
          feedback: requestData.feedback || {},
          notes: requestData.notes || [],
          sector: requestData.sector || '',
          attachments: requestData.attachments || [],
          log: requestData.log || [],
          procedure_deviation: requestData.procedure_deviation || null,
          sla: requestData.sla ? this.handleSolicitationSLA(requestData, false, false) : null,
          sla_att: requestData.sla_att ? this.handleSolicitationSLA(requestData, true, false) : null,
        }

        if(infoModal.feedback.updated_at){
          infoModal.feedback.updated_at = moment(item.feedback.updated_at).format('DD/MM/YYYY \à\\s HH:mm')
        }

        infoModal.email_data = emailData || [];
        infoModal.primary_email_id = emailData?.[0]?.id ?? null;
        infoModal.wpp_groups = this.wppGroups;
        infoModal.email_groups = this.emailGroups;

        if(Object.keys(survey).length){
          let avaliacao;
          if(survey.grade === 1) avaliacao = '😫 Péssimo' 
          if(survey.grade === 2) avaliacao = '☹️ Ruim' 
          if(survey.grade === 3) avaliacao = '😐 Regular' 
          if(survey.grade === 4) avaliacao = '🙂 Bom' 
          if(survey.grade === 5) avaliacao = '😀 Ótimo' 
          const surveyObj = {
            avaliacao,
            reason: survey.reason
          }
          infoModal.survey = surveyObj;
        }
        await this.setLogChat(infoModal);
  
        this.$refs.detailsModal.openModal();
      }
    },

    formTelefone(tel) {
        tel=tel.replace(/\D/g,"")
        tel=tel.replace(/^(\d)/,"+$1")
        tel=tel.replace(/(.{3})(\d)/,"$1($2")
        tel=tel.replace(/(.{6})(\d)/,"$1)$2")
        if(tel.length == 12) {
            tel=tel.replace(/(.{1})$/,"-$1")
        } else if (tel.length == 13) {
            tel=tel.replace(/(.{2})$/,"-$1")
        } else if (tel.length == 14) {
            tel=tel.replace(/(.{3})$/,"-$1")
        } else if (tel.length == 15) {
            tel=tel.replace(/(.{4})$/,"-$1")
        } else if (tel.length > 15) {
            tel=tel.replace(/(.{4})$/,"-$1")
        }
        tel=tel.replace("("," (");
        tel=tel.replace(")",") ");

        return tel;
    },
    getRequests(){
      this.items = [];
      let tempArray = [];
      axios.get('/solicitacoes/getAllRequests', {params: {start: this.filters.startDate, end: this.filters.endDate}}).then(({data}) => {
        if(data.length > 0){
          data.forEach(el => {
            const obj = {...el}
            obj.phone = el.client_id.substring(0, el.client_id.indexOf('@'))
            if(!obj.reason) obj.reason = '---' 
            if(!obj.ponto_name) obj.ponto_name = '---'
            if(!obj.client_name) obj.client_name = '---'
            if(!obj.cnpj) obj.cnpj = '---'
            obj.channel = this.parseChannel(obj)
            obj.requestType = {type: el.type, subject: el.subject, reason: el.reason}
            obj.created_by = this.parseCreator(obj)
            tempArray.push(obj)
          })
        }
        this.items = tempArray;
        this.tryAutoOpen();
      })
    },

    procedureDeviationColumns(item) {
      const deviation = item?.procedure_deviation?.has_deviation ? item.procedure_deviation : null;
      return {
        'Desvio de Procedimento': deviation ? 'Sim' : 'Não',
        'Justificativa do Desvio': deviation?.justification || '',
        'Desvio Registrado por': deviation?.updated_by || '',
        'Data do Registro do Desvio': deviation?.updated_at ? moment(deviation.updated_at).format('DD/MM/YYYY HH:mm:ss') : '',
      };
    },
    resetFilters(){
      this.filters = {
        startDate: '',
        endDate: '',
      }
      this.statusFilter = '*'
      this.searchTerm = ''
      this.sectorFilter = '*'
      this.reasonFilter = '*'
      this.deviationFilter = '*'
      this.getRequests();
    },

    generateExcel() {
      const fieldsGeral = this.filteredItems.map(item => {
        console.log('item', item)
        return {
          'Data de criação': moment(item.created_at).unix(),
          'Criado por': this.parseCreator(item),
          'Data de alteração': moment(item.updated_at).unix(),
          'Alterado por': item.updated_by,
          'Chamado': item.protocol,
          'Protocolo': item.attProtocol,
          'Motivo de Acionamento': this.parseReason(item.requestType),
          'Canal': this.parseChannel(item),
          'Status': item.status,
          'Área Responsável': item.sector || 'Não atribuído' ,
          'Solicitante': item.name || 'Não identificado',
          'Telefone': this.formTelefone(item.client_id.substring(0, item.client_id.indexOf('@'))),
          'E-mail': item.email || "",
          'CNPJ': (!item.cnpj || item.cnpj == '0') ? 'Não informado' : item.cnpj,
          'Estabelecimento': item.ponto_name || "",
          'Razão Social': item.client_name || "",
          'Código do Ponto': item.ponto_cod || "",
          'Endereço': item.address || "",
          ...this.procedureDeviationColumns(item),
        }
      }).sort((a,b) => {
        if(a['Data de criação'] < b['Data de criação']) return 1;
        if(a['Data de criação'] > b['Data de criação']) return -1;
      });

      const fieldsColaboradores = this.filteredItems.filter(
        el => el.subject === 'colaborador'
      ).map(item => {
        return {
          'Data de criação': moment(item.created_at).unix(),
          'Criado por': this.parseCreator(item),
          'Data de alteração': moment(item.updated_at).unix(),
          'Alterado por': item.updated_by,
          'Chamado': item.protocol,
          'Protocolo': item.attProtocol,
          'Motivo de Acionamento': this.parseReason(item.requestType),
          'Canal': this.parseChannel(item),
          'Status': item.status,
          'Área Responsável': item.sector || 'Não atribuído' ,
          'Solicitante': item.name || 'Não identificado',
          'Telefone': this.formTelefone(item.client_id.substring(0, item.client_id.indexOf('@'))),
          'E-mail': item.email || "",
          'CNPJ': (!item.cnpj || item.cnpj == '0') ? 'Não informado' : item.cnpj,
          'Cidade': item.cidade || '',
          'Estabelecimento': item.ponto_name || "",
          'Razão Social': item.client_name || "",
          'Código do Ponto': item.ponto_cod || "",
          'Endereço': item.address || "",
          'Matrícula': item.matricula || "",
          ...this.procedureDeviationColumns(item),
        }
      }).sort((a,b) => {
        if(a['Data de criação'] < b['Data de criação']) return 1;
        if(a['Data de criação'] > b['Data de criação']) return -1;
      });

      const fieldsElogios = this.filteredItems.filter(
        el => el.type === 'elogio' && el.subject !== 'colaborador'
      ).map(item => {
        return {
          'Data de criação': moment(item.created_at).unix(),
          'Criado por': this.parseCreator(item),
          'Data de alteração': moment(item.updated_at).unix(),
          'Alterado por': item.updated_by,
          'Chamado': item.protocol,
          'Protocolo': item.attProtocol,
          'Motivo de Acionamento': this.parseReason(item.requestType),
          'Canal': this.parseChannel(item),
          'Status': item.status,
          'Área Responsável': item.sector || 'Não atribuído' ,
          'Solicitante': item.name || 'Não identificado',
          'Telefone': this.formTelefone(item.client_id.substring(0, item.client_id.indexOf('@'))),
          'E-mail': item.email || "",
          'CNPJ': (!item.cnpj || item.cnpj == '0') ? 'Não informado' : item.cnpj,
          'Cidade': item.cidade || '',
          'Estabelecimento': item.ponto_name || "",
          'Razão Social': item.client_name || "",
          'Código do Ponto': item.ponto_cod || "",
          'Endereço': item.address || "",
          ...this.procedureDeviationColumns(item),
        }
      }).sort((a,b) => {
        if(a['Data de criação'] < b['Data de criação']) return 1;
        if(a['Data de criação'] > b['Data de criação']) return -1;
      });

      const fieldsConduta = this.filteredItems.filter(
        el => el.subject === 'conduta'
      ).map(item => {
        return {
          'Data de criação': moment(item.created_at).unix(),
          'Criado por': this.parseCreator(item),
          'Data de alteração': moment(item.updated_at).unix(),
          'Alterado por': item.updated_by,
          'Chamado': item.protocol,
          'Protocolo': item.attProtocol,
          'Motivo de Acionamento': this.parseReason(item.requestType),
          'Canal': this.parseChannel(item),
          'Status': item.status,
          'Área Responsável': item.sector || 'Não atribuído' ,
          'Solicitante': item.name || 'Não identificado',
          'Telefone': this.formTelefone(item.client_id.substring(0, item.client_id.indexOf('@'))),
          'E-mail': item.email || "",
          'CNPJ': (!item.cnpj || item.cnpj == '0') ? 'Não informado' : item.cnpj,
          'Cidade': item.cidade || '',
          'Estabelecimento': item.ponto_name || "",
          'Razão Social': item.client_name || "",
          'Código do Ponto': item.ponto_cod || "",
          'Endereço': item.address || "",
          ...this.procedureDeviationColumns(item),
        }
      }).sort((a,b) => {
        if(a['Data de criação'] < b['Data de criação']) return 1;
        if(a['Data de criação'] > b['Data de criação']) return -1;
      });

      const fieldsTransito = this.filteredItems.filter(
        el => el.subject === 'transito'
      ).map(item => {
        return {
          'Data de criação': moment(item.created_at).unix(),
          'Criado por': this.parseCreator(item),
          'Data de alteração': moment(item.updated_at).unix(),
          'Alterado por': item.updated_by,
          'Chamado': item.protocol,
          'Protocolo': item.attProtocol,
          'Motivo de Acionamento': this.parseReason(item.requestType),
          'Canal': this.parseChannel(item),
          'Status': item.status,
          'Área Responsável': item.sector || 'Não atribuído' ,
          'Solicitante': item.name || 'Não identificado',
          'Telefone': this.formTelefone(item.client_id.substring(0, item.client_id.indexOf('@'))),
          'E-mail': item.email || "",
          'CNPJ': (!item.cnpj || item.cnpj == '0') ? 'Não informado' : item.cnpj,
          'Cidade': item.cidade || '',
          'Estabelecimento': item.ponto_name || "",
          'Razão Social': item.client_name || "",
          'Código do Ponto': item.ponto_cod || "",
          'Endereço': item.address || "",
          'Placa do Solicitante': item.placa_solicitante || '',
          'Placa do Veículo': item.placa || '',
          'Nome da Base': item.nomeBase || '',
          'Sigla da Base': item.siglaBase || '',
          'Prefixo': item.prefixo || '',
          'Sufixo': item.sufixo || '',
          'Local': item.local || '',
          ...this.procedureDeviationColumns(item),
        }
      }).sort((a,b) => {
        if(a['Data de criação'] < b['Data de criação']) return 1;
        if(a['Data de criação'] > b['Data de criação']) return -1;
      });

      const fieldsAtraso = this.filteredItems.filter(
        el => el.subject === 'atraso'
      ).map(item => {
        return {
          'Data de criação': moment(item.created_at).unix(),
          'Criado por': this.parseCreator(item),
          'Data de alteração': moment(item.updated_at).unix(),
          'Alterado por': item.updated_by,
          'Chamado': item.protocol,
          'Protocolo': item.attProtocol,
          'Motivo de Acionamento': this.parseReason(item.requestType),
          'Canal': this.parseChannel(item),
          'Status': item.status,
          'Área Responsável': item.sector || 'Não atribuído' ,
          'Solicitante': item.name || 'Não identificado',
          'Telefone': this.formTelefone(item.client_id.substring(0, item.client_id.indexOf('@'))),
          'E-mail': item.email || "",
          'CNPJ': (!item.cnpj || item.cnpj == '0') ? 'Não informado' : item.cnpj,
          'Cidade': item.cidade || '',
          'Estabelecimento': item.ponto_name || "",
          'Razão Social': item.client_name || "",
          'Código do Ponto': item.ponto_cod || "",
          'Endereço': item.address || "",
          'Data Prevista': item.data || '',
          'Hora Prevista': item.hora || '',
          ...this.procedureDeviationColumns(item),
        }
      }).sort((a,b) => {
        if(a['Data de criação'] < b['Data de criação']) return 1;
        if(a['Data de criação'] > b['Data de criação']) return -1;
      });

      const fieldsOutros = this.filteredItems.filter(
        el => el.type === 'outros'
      ).map(item => {
        return {
          'Data de criação': moment(item.created_at).unix(),
          'Criado por': this.parseCreator(item),
          'Data de alteração': moment(item.updated_at).unix(),
          'Alterado por': item.updated_by,
          'Chamado': item.protocol,
          'Protocolo': item.attProtocol,
          'Motivo de Acionamento': this.parseReason(item.requestType),
          'Canal': this.parseChannel(item),
          'Status': item.status,
          'Área Responsável': item.sector || 'Não atribuído' ,
          'Solicitante': item.name || 'Não identificado',
          'Telefone': this.formTelefone(item.client_id.substring(0, item.client_id.indexOf('@'))),
          'E-mail': item.email || "",
          'CNPJ': (!item.cnpj || item.cnpj == '0') ? 'Não informado' : item.cnpj,
          'Cidade': item.cidade || '',
          'Estabelecimento': item.ponto_name || "",
          'Razão Social': item.client_name || "",
          'Código do Ponto': item.ponto_cod || "",
          'Endereço': item.address || "",
          ...this.procedureDeviationColumns(item),
        }
      }).sort((a,b) => {
        if(a['Data de criação'] < b['Data de criação']) return 1;
        if(a['Data de criação'] > b['Data de criação']) return -1;
      });

      const file = XLSX.utils.book_new();

      if(fieldsGeral.length){
        const ordered = fieldsGeral;
        ordered.forEach(el => {
          el['Data de alteração'] = moment.unix(el['Data de alteração']).format('DD/MM/YYYY \à\\s HH:mm')
          el['Data de criação'] = moment.unix(el['Data de criação']).format('DD/MM/YYYY \à\\s HH:mm')
        })
        
        const sheet = XLSX.utils.json_to_sheet(ordered);
        XLSX.utils.book_append_sheet(file, sheet, "Solicitações");
      }

      if(fieldsColaboradores.length){
        const ordered = fieldsColaboradores;
        ordered.forEach(el => {
          el['Data de alteração'] = moment.unix(el['Data de alteração']).format('DD/MM/YYYY \à\\s HH:mm')
          el['Data de criação'] = moment.unix(el['Data de criação']).format('DD/MM/YYYY \à\\s HH:mm')
        })
        
        const sheet = XLSX.utils.json_to_sheet(ordered);
        XLSX.utils.book_append_sheet(file, sheet, "Solicitações de Colaboradores");
      }

      if(fieldsElogios.length){
        const ordered = fieldsElogios;
        ordered.forEach(el => {
          el['Data de alteração'] = moment.unix(el['Data de alteração']).format('DD/MM/YYYY \à\\s HH:mm')
          el['Data de criação'] = moment.unix(el['Data de criação']).format('DD/MM/YYYY \à\\s HH:mm')
        })
        
        const sheet = XLSX.utils.json_to_sheet(ordered);
        XLSX.utils.book_append_sheet(file, sheet, "Elogios");
      }

      if(fieldsConduta.length){
        const ordered = fieldsConduta;
        ordered.forEach(el => {
          el['Data de alteração'] = moment.unix(el['Data de alteração']).format('DD/MM/YYYY \à\\s HH:mm')
          el['Data de criação'] = moment.unix(el['Data de criação']).format('DD/MM/YYYY \à\\s HH:mm')
        })
        
        const sheet = XLSX.utils.json_to_sheet(ordered);
        XLSX.utils.book_append_sheet(file, sheet, "Conduta de Colaborador");
      }

      if(fieldsTransito.length){
        const ordered = fieldsTransito;
        ordered.forEach(el => {
          el['Data de alteração'] = moment.unix(el['Data de alteração']).format('DD/MM/YYYY \à\\s HH:mm')
          el['Data de criação'] = moment.unix(el['Data de criação']).format('DD/MM/YYYY \à\\s HH:mm')
        })
        
        const sheet = XLSX.utils.json_to_sheet(ordered);
        XLSX.utils.book_append_sheet(file, sheet, "Ocorrências de Trânsito");
      }

      if(fieldsAtraso.length){
        const ordered = fieldsAtraso;
        ordered.forEach(el => {
          el['Data de alteração'] = moment.unix(el['Data de alteração']).format('DD/MM/YYYY \à\\s HH:mm')
          el['Data de criação'] = moment.unix(el['Data de criação']).format('DD/MM/YYYY \à\\s HH:mm')
        })
        
        const sheet = XLSX.utils.json_to_sheet(ordered);
        XLSX.utils.book_append_sheet(file, sheet, "Atraso de Atendimento");
      }

      if(fieldsOutros.length){
        const ordered = fieldsOutros;
        ordered.forEach(el => {
          el['Data de alteração'] = moment.unix(el['Data de alteração']).format('DD/MM/YYYY \à\\s HH:mm')
          el['Data de criação'] = moment.unix(el['Data de criação']).format('DD/MM/YYYY \à\\s HH:mm')
        })
        
        const sheet = XLSX.utils.json_to_sheet(ordered);
        XLSX.utils.book_append_sheet(file, sheet, "Outros");
      }

      XLSX.writeFile(file,'Solicitações.xlsx');
    },

    parseType(type) {
      if(type === 'elogio') return 'Elogio'
      if(type === 'reclamacao') return 'Reclamação'
      if(type === 'outros') return 'Outros'
    },

    parseSubject(subject) {
      if(subject === 'conduta') return 'Conduta de Colaborador'
      if(subject === 'atraso') return 'Atraso de Atendimento'
      if(subject === 'transito') return 'Ocorrência de Trânsito'
      if(subject === 'colaborador') return 'Solicitação de Colaborador'
      return subject || '---';
    },

    parseCreator(data){
      if(data.client_id.includes('@s.whatsapp')) return 'Atendimento BOT'
      return data.created_by;
    },

    parseReason(data, origin = 'table'){
      let string = '';
      let type = '';
      let subject = '';
      
      if(origin === 'details'){
        if(data.motivo) return data.motivo
        type = this.parseType(data.tipo)
        subject = this.parseSubject(data.assunto)
      } else {
        if(data.reason) return data.reason
        type = this.parseType(data.type)
        subject = this.parseSubject(data.subject)
      }

      if(type && subject){
        string = `${type} - ${subject}`
      } else if(!type && subject){
        string = subject
      } else if(type && !subject){
        string = type
      }

      return string
    },
    parseChannel(data){
      if(data.channel){
        if(data.channel === 'wpp') return 'Whatsapp';
        return data.channel
      } else {
        return data.client_id.includes('operatorForm') ? 'Formulário' : 'Whatsapp'
      }
    },
    tryAutoOpen() {
      if (!this.autoOpenProtocol || this.autoOpenTriggered) return;
      const item = this.items.find(el => el.protocol === this.autoOpenProtocol);
      if (item) {
        this.autoOpenTriggered = true;
        this.getDetails({ item, reloadDetails: true });
      }
    },
  },
  mounted() {
    // this.filters.startDate = moment().startOf('month').format('YYYY-MM-DD');
  	// this.filters.endDate = moment().format('YYYY-MM-DD');
    this.getRequests()
  },
  watch: {
    statusFilter(newVal) {
      if (newVal !== 'Fechado' && (this.filters.startDate || this.filters.endDate)) {
        this.filters.startDate = '';
        this.filters.endDate = '';
        this.getRequests();
      }
    }
  },
}
</script>

<style scoped lang="scss">
.bgModalHeader{
  background-color: #1c859a;
  color: #FFFFFF;
}
.modal-content{
  border-radius: 3rem;
}
.custom-width {
  width: unset !important;
  border-radius: 10px !important;
}

.filter-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;
  align-items: flex-start;
}

.filter-group {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  width: 100%;
  flex-wrap: wrap;
}
#date-filter{
  display: flex;
  flex: 1;
  align-items: center;
}
.header-filter{
  display: flex;
  align-items: center;
  font-size: small;

  label {
    white-space: nowrap
  }
}

.filter-buttons{
  border-radius: 10px !important;
  font-weight: bold;
  color: white;
  margin-left: 5px;
  padding: 5px 10px;
  transition: 0.2s;
}

#search-button{
  background-color: #1c8498;
  border: 2px solid #1c8498;
  display: flex;
  align-items: center;
  gap: 4px;
}

#search-button:hover {
  background-color: #1c849845;
  color: #1c8498;
}

#reset-button{
  background-color: #e3342f;
  border: 2px solid #e3342f;
  display: flex;
  align-items: center;
  gap: 4px;
}

#reset-button:hover {
  background-color: #e3342f6e;
  color: #e3342f;
}

.search-container {
  width: 100% !important;
  input {
    width: 100% !important;
  }
}

label {
  margin: 0px 10px;
  font-weight: bold;
}
</style>

